import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface AddressSearchData {
  cep: string;
  logradouro: string;
  numero: string;
  bairro: string;
  cidade: string;
  estado: string;
  enderecoFormatado: string;
}

export interface AddressSearchResponse {
  enderecosEncontrados: AddressSearchData[];
  usouSugestao: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AddressSearchApiService {
  private API = `${environment.angularJSconstants.PUBLIC_API_LUCENE}`;
  constructor(private http: HttpClient) { }

  public searchAddress(needle: string): Observable<AddressSearchResponse> {
    return this.http.get<AddressSearchResponse>(`${this.API}/address/search`, {
      params: {
        q: needle,
      },
    });
  }
}
